<template>
  <ProjectWrapepr :parent="$parent" v-if="$parent.projects.length"></ProjectWrapepr>
</template>

<script>
import ProjectWrapepr from "../components/project-wrapper.vue";

export default {
  name: "main-canvas",
  components: {
    ProjectWrapepr
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
